import { amtStr } from '@ifca-root/react-component/src/helpers/StringNumberFunction/numFormatter'
import { Grid } from '@material-ui/core'
import { formatDateAndTime } from 'helpers/StringNumberFunction/FormatDate'
import React from 'react'

export const InboundDocDetail = ({ data }) => {
  return (
    <Grid container>
      {/* <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Module Name
          </div>
          <div className="mdDesc">{data?.ModuleName ?? '—'}</div>
        </div>
      </Grid> */}
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Document Type
          </div>
          <div className="mdDesc">{data?.trx_type ?? '—' ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={8}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            e-Invoice Number
          </div>
          <div className="mdDesc">{data?.trx_doc_no ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            e-Invoice Ref No
          </div>
          <div className="mdDesc">{data?.eInvRefNo ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={8}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            e-Invoice Date
          </div>
          <div className="mdDesc">
            {data?.trx_doc_date
              ? formatDateAndTime(new Date(data?.trx_doc_date))
              : '—'}
          </div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            e-Invoice Transaction No
          </div>
          <div className="mdDesc">{data?.irbm_trx_no ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            e-Invoice Long Id
          </div>
          <div className="mdDesc">{data?.irbm_long_id ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            e-Invoice Type
          </div>
          <div className="mdDesc">{data?.e_inv_type ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Currency Code
          </div>
          <div className="mdDesc">{data?.trx_doc_currency_code ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Base Currency Code
          </div>
          <div className="mdDesc">{data?.trx_target_currency_code ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Currency Rate
          </div>
          <div className="mdDesc">{amtStr(data?.trx_currency_rate) ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Bill Frequency
          </div>
          <div className="mdDesc">{data?.trx_bill_frequency ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Bill Start Date
          </div>
          <div className="mdDesc">
            {data?.trx_bill_start_date
              ? formatDateAndTime(new Date(data?.trx_bill_start_date))
              : '—'}
          </div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Bill End Date
          </div>
          <div className="mdDesc">
            {data?.trx_bill_end_date
              ? formatDateAndTime(new Date(data?.trx_bill_end_date))
              : '—'}
          </div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Payment Mode
          </div>
          <div className="mdDesc">{data?.trx_payment_mode ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={8}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Payment Term
          </div>
          <div className="mdDesc">{data?.trx_payment_term ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Total Excluding Tax
          </div>
          <div className="mdDesc">
            {data?.trx_total_exclude_tax_amount
              ? amtStr(data?.trx_total_exclude_tax_amount)
              : '—'}
          </div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Total Including Tax
          </div>
          <div className="mdDesc">
            {data?.trx_total_include_tax_amount
              ? amtStr(data?.trx_total_include_tax_amount)
              : '—'}
          </div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Total Payable Amount
          </div>
          <div className="mdDesc">
            {data?.trx_total_payable_amount
              ? amtStr(data?.trx_total_payable_amount)
              : '—'}
          </div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Total Net
          </div>
          <div className="mdDesc">
            {data?.trx_total_net_amount
              ? amtStr(data?.trx_total_net_amount)
              : '—'}
          </div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Total Discount
          </div>
          <div className="mdDesc">
            {data?.trx_total_discount_amount
              ? amtStr(data?.trx_total_discount_amount)
              : '—'}
          </div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Total Tax
          </div>
          <div className="mdDesc">
            {data?.trx_total_tax_amount
              ? amtStr(data?.trx_total_tax_amount)
              : '—'}
          </div>
        </div>
      </Grid>
      <Grid item sm={12} md={8}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Total Rounding Amount
          </div>
          <div className="mdDesc">
            {data?.trx_total_rounding_amount
              ? amtStr(data?.trx_total_rounding_amount)
              : '—'}
          </div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Pre Pay Date
          </div>
          <div className="mdDesc">
            {data?.trx_pre_pay_date
              ? formatDateAndTime(new Date(data?.trx_pre_pay_date))
              : '—'}
          </div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Pre Pay Ref No
          </div>
          <div className="mdDesc">{data?.trx_pre_pay_refno ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Pre Pay Amount
          </div>
          <div className="mdDesc">
            {data?.trx_pre_pay_amount ? amtStr(data?.trx_pre_pay_amount) : '—'}
          </div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Custom Import Form
          </div>
          <div className="mdDesc">{data?.trx_custom_import_form ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={8}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            K2 Form
          </div>
          <div className="mdDesc">{data?.trx_k2 ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Inco Terms
          </div>
          <div className="mdDesc">{data?.trx_inco_terms ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={8}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            FTA
          </div>
          <div className="mdDesc">{data?.trx_fta ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Exporter No
          </div>
          <div className="mdDesc">{data?.trx_exporter_no ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={8}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Exporter Agency
          </div>
          <div className="mdDesc">{data?.trx_exporter_agency ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Other Charges Document No
          </div>
          <div className="mdDesc">{data?.trx_other_charges_refno ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Other Charges Amount
          </div>
          <div className="mdDesc">
            {data?.OtherChargesAmt
              ? amtStr(data?.trx_other_charges_amount)
              : '—'}
          </div>
        </div>
      </Grid>
      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Other Charges Reason
          </div>
          <div className="mdDesc">{data?.trx_other_charges_reason ?? '—'}</div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Tax Exemp
          </div>
          <div className="mdDesc">{data?.trx_tax_exemption_type ?? '—'}</div>
        </div>
      </Grid>
      <Grid item sm={12} md={8}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Tax Exemp Amount
          </div>
          <div className="mdDesc">
            {data?.TaxExempAmt ? amtStr(data?.TaxExempAmt) : '—'}
          </div>
        </div>
      </Grid>

      <Grid item sm={12} md={4}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            Send Time
          </div>
          <div className="mdDesc">
            {data?.irbm_send_ts
              ? formatDateAndTime(new Date(data?.irbm_send_ts))
              : '—'}
          </div>
        </div>
      </Grid>
      <Grid item sm={12} md={8}>
        <div className="content-wrap full">
          <div className="desc" style={{ color: 'grey' }}>
            e-Validate Time
          </div>
          <div className="mdDesc">
            {data?.irbm_validate_ts
              ? formatDateAndTime(new Date(data?.irbm_validate_ts))
              : '—'}
          </div>
        </div>
      </Grid>
    </Grid>
  )
}
